import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Stack, TextField, Divider, Alert, Snackbar, Checkbox, Link, Card, CardContent, Grid2, CardHeader } from "@mui/material";
import { isStudent, useAuth } from "../../contexts/AuthContext";
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import AsyncButton from "../../components/common/AsyncButton";
import { useAsyncAction } from "../../components/common/useAsyncAction";
import { SampleData, AddedQuestionSampleData } from "./SampleData";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { StyledTableCell, StyledTableRow } from '../../theme';
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { InvokeAPI } from "../../apis/API";
import { getAssessmentMgmtBase } from "../../config/apiBase";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { AddCircle } from "@mui/icons-material";



const AssessmentAssignEdit = () => {
    const { id } = useParams();

    const navigate = useNavigate();
    const { user, logout } = useAuth();
    const [state, setState] = useState({ open: false, severity: "", message: "" })
    const handleClose = () => {
        setState({ ...state, open: false });
    };

    const [metaData, setMetaData] = useState({
        name: '',
        subject: '',
        class: '',
        status: '',
    });
    const getAssessmentMeta = async () => {
        const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/id`,
            { "ID": id },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        //console.log(uinfo.response)
        return uinfo.response["AssessmentInfo"]
    }

    const [unassigned, setUnassigned] = useState({
        users: [],
        groups: [],
    });

    const getAssessmentAssignedTo = async () => {
        const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assignment/unassigned`,
            { "Aid": id },
            'POST',
            { "authorization": user["token"] },
            false)
        if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
            logout(user);
        }
        //console.log(uinfo.response)
        return uinfo.response
    }

    useEffect(() => {
        getAssessmentMeta().then(data => setMetaData({ name: data.Aname, class: data.Aclass, subject: data.Asubject, status: data.Astatus }))
        getAssessmentAssignedTo().then(data => setUnassigned({ ...unassigned, users: data["UsersInfo"], groups: data["GroupsInfo"] }))
    }, [])


    const RenderAssignTo = () => {
        //Get /v1/user/enrolled
        //Get assessment assignedTo Users
        //What is not assigned show in the list - the list to be checkbox based
        //Assign button
        //Delete button to unassign
        const [selectedUsers, setSelectedUsers] = useState({})
        const [selectedGroups, setSelectedGroups] = useState({})
        const { run: runAssign, loading: assigning } = useAsyncAction();

        const handleUserSelect = (e) => {
            e.preventDefault();
            const name = e.target.id
            const value = e.target.checked
            setSelectedUsers({ ...selectedUsers, [name]: value })
            //console.log(e.target.id)
            //console.log(e.target.checked)
        }

        const handleGroupSelect = (e) => {
            e.preventDefault();
            //console.log(e.target.name)
            //console.log(e.target.checked)
            const name = e.target.id
            const value = e.target.checked
            setSelectedGroups({ ...selectedGroups, [name]: value })
        }

        //console.log(selectedUsers)
        //console.log(selectedGroups)

        const handleAddParticipant = async (e) => {
            e.preventDefault();
            await runAssign(async () => {
                const listOfUsers = [];
                const listOfGroups = [];
                for (const [key, value] of Object.entries(selectedUsers)) {
                    if (value == true) {
                        listOfUsers.push(key)
                    }
                }
                for (const [key, value] of Object.entries(selectedGroups)) {
                    if (value == true) {
                        listOfGroups.push(key)
                    }
                }
                console.log(listOfUsers)
                console.log(listOfGroups)
                const uinfo = await InvokeAPI(`${getAssessmentMgmtBase()}/v1/assessment/assignment/create`,
                    {
                        "Aid": id,
                        "UserID": listOfUsers,
                        "GroupID": listOfGroups
                    },
                    'POST',
                    { "authorization": user["token"] },
                    false)
                if (uinfo["unauthenticated"] == true || uinfo["unauthorized"] == true) {
                    logout(user);
                } else {
                    setState({ open: true, severity: "success", message: "Assessment assigned successfully" })
                    if (metaData.status === "draft") {
                        navigate("/app/practice/edit/" + id)
                    } else {
                        navigate("/app/practice/")
                    }

                }
            });
        }


        return (
            <Box style={{ padding: "10px 10px 10px 10px" }}>
                <Box sx={{ paddingBottom: "20px" }}>
                    <Typography sx={{ fontWeight: 600, mb: 2, textAlign: 'center' }} variant="h6">Select users:</Typography>
                    <Box sx={{ borderRadius: 2, overflow: 'hidden', mb: 3 }}>
                        <TableContainer component={Paper}>
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell
                                            sx={{
                                                borderTopLeftRadius: '12px',
                                                '&:first-of-type': {
                                                    borderTopLeftRadius: '12px'
                                                }
                                            }}
                                        >
                                            UserName
                                        </StyledTableCell>
                                        <StyledTableCell>First Name</StyledTableCell>
                                        <StyledTableCell
                                            sx={{
                                                borderTopRightRadius: '12px',
                                                '&:last-of-type': {
                                                    borderTopRightRadius: '12px'
                                                }
                                            }}
                                        >
                                            Last Name
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {unassigned.users && unassigned.users.length > 0 ? (
                                        unassigned.users.map((row, idx) => {
                                            const isLast = idx === unassigned.users.length - 1;
                                            return (
                                                <StyledTableRow key={row.Username}>
                                                    <StyledTableCell
                                                        component="th"
                                                        scope="row"
                                                        sx={isLast ? {
                                                            borderBottomLeftRadius: '12px',
                                                            paddingBottom: '16px',
                                                            paddingLeft: '16px'
                                                        } : { paddingLeft: '16px' }}
                                                    >
                                                        <Checkbox checked={selectedUsers[row.ID]} id={row.ID} onChange={handleUserSelect} />{row.Username} &nbsp;
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        sx={isLast ? { paddingBottom: '16px' } : {}}
                                                    >
                                                        {row.Fname}
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        sx={isLast ? {
                                                            borderBottomRightRadius: '12px',
                                                            paddingBottom: '16px',
                                                            paddingRight: '16px'
                                                        } : { paddingRight: '16px' }}
                                                    >
                                                        {row.Lname}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            );
                                        })
                                    ) : (
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={3} sx={{ textAlign: 'center', py: 3 }}>
                                                No users available
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                    <Typography display="none" sx={{ fontWeight: 600, mb: 2, textAlign: 'center' }} variant="h6">Select groups:</Typography>
                    <Box display="none" sx={{ borderRadius: 2, overflow: 'hidden' }}>
                        <TableContainer component={Paper}>
                            <Table aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell
                                            sx={{
                                                borderTopLeftRadius: '12px',
                                                '&:first-of-type': {
                                                    borderTopLeftRadius: '12px'
                                                }
                                            }}
                                        >
                                            Name
                                        </StyledTableCell>
                                        <StyledTableCell
                                            sx={{
                                                borderTopRightRadius: '12px',
                                                '&:last-of-type': {
                                                    borderTopRightRadius: '12px'
                                                }
                                            }}
                                        >
                                            Description
                                        </StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody display="none">
                                    {/*
                                    unassigned.groups && unassigned.groups.length > 0 ? (
                                        unassigned.groups.map((row, idx) => {
                                            const isLast = idx === unassigned.groups.length - 1;
                                            return (
                                                <StyledTableRow key={row.Gname}>
                                                    <StyledTableCell 
                                                        component="th" 
                                                        scope="row"
                                                        sx={isLast ? { 
                                                            borderBottomLeftRadius: '12px',
                                                            paddingBottom: '16px',
                                                            paddingLeft: '16px'
                                                        } : { paddingLeft: '16px' }}
                                                    >
                                                        <Checkbox checked={selectedGroups[row.ID]} id={row.ID} onChange={handleGroupSelect} />
                                                        <Link component="button" underline="none" onClick={() => { navigate("/app/group/" + row.ID) }}>{row.Gname}</Link>
                                                    </StyledTableCell>
                                                    <StyledTableCell
                                                        sx={isLast ? { 
                                                            borderBottomRightRadius: '12px',
                                                            paddingBottom: '16px',
                                                            paddingRight: '16px'
                                                        } : { paddingRight: '16px' }}
                                                    >
                                                        {row.Gdescription}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            );
                                        })
                                    ) : (
                                        <StyledTableRow>
                                            <StyledTableCell colSpan={2} sx={{ textAlign: 'center', py: 3 }}>
                                                No groups available
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )
                                        */}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
                <Box display="flex" justifyContent="center" alignItems="center">
                    <AsyncButton sx={{ textTransform: "initial" }} type="submit" variant="contained" color="primary" onClick={handleAddParticipant} loading={assigning} >
                        <AddCircle /> &nbsp; Add Participant(s)
                    </AsyncButton>
                </Box>
            </Box>
        );
    }


    return (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin', paddingBottom: '80px' }}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={state.open}
                onClose={handleClose}
                key={state.message}
                autoHideDuration={1000}
            >
                <Alert variant="filled" severity={state.severity}>
                    {state.message}
                </Alert>
            </Snackbar>
            <Button
                variant="text"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(-1)}
                sx={{ color: "blue" }}
            >
                Go Back
            </Button>
            {isStudent() ? (<>You are not allowed to edit this.</>) : (
                <Card
                    elevation={6}
                    sx={{
                        borderRadius: 4,
                        border: '1px solid',
                        borderColor: 'divider',
                        boxShadow: '0 4px 16px rgba(0,0,0,0.1), 0 0 0 1px rgba(0,0,0,0.05)',
                        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                        '&:hover': {
                            boxShadow: '0 8px 24px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)',
                            transform: 'translateY(-2px)',
                        },
                    }}
                >
                    <CardHeader
                        sx={{ textAlign: 'center', pb: 1 }}
                        title={
                            <Typography
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '1.125rem',
                                    color: 'text.primary',
                                    letterSpacing: '-0.01em',
                                    textAlign: 'center',
                                    width: '100%'
                                }}
                                variant="h6"
                            >
                                Assignment For: {metaData.name}
                            </Typography>
                        }
                    />
                    <CardContent sx={{ paddingTop: "5px" }}>
                        <Stack>
                            <RenderAssignTo />
                        </Stack>
                    </CardContent>
                </Card>
            )
            }

        </Box>
    );
};

export default AssessmentAssignEdit;